// FIXME: typescript enum
angular.module('capability-ng-scheduler').constant(
  'CampusLocationEnum',
  Enumeration('CampusLocationEnum', {
    BLENDED: {
      id: 'blended',
      title: 'Blended - Partially Online',
      label: 'Blended - Partially Online',
      shortTitle: 'Blended',
      is_online: true
    },
    ONLINE_COURSE: {
      id: 'online_course',
      title: 'Online Courses',
      label: 'Online Courses',
      shortTitle: 'Online',
      is_online: true
    }
  })
);



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/views/components/preferences/components/campus_location/types/campus_location_enum.js